'use strict';
const angular = require('angular');

/*@ngInject*/
export function ServiceRequestTicketsService($resource) {
  return $resource('/api/servicerequests/:id', {
    name: '@_id'
  },{
    update: {
      method: 'PUT'
    },
    patch: {
      method: 'PATCH'
    },
    getByProperty: {
      method: 'GET',
      url: "/api/servicerequests/property/:id",
      isArray: true
    },
    addAttachments: {
      method: 'PUT',
      url: "/api/servicerequests/:id/attachments"
    }
  });
}


export default angular.module('conduu.ServiceRequestTicketsService', [])
  .factory('ServiceRequestTicketsService', ServiceRequestTicketsService)
  .name;



// WEBPACK FOOTER //
// ./client/components/servicerequest-tickets/servicerequest-tickets.service.js